import * as React from 'react';
import BubbleDragContainer from '../BubbleDragContainer';
import { getTranslation } from '@nexxt/common/services/TextService';
import { useTranslation } from 'react-i18next';
import ValidationService from '@nexxt/common/services/ValidationService';
interface TextBubbleProps {
    index: number; // for sortableElement
    content: any;
    langName: string;
    defaultText?: string;
    disableAddBubble?: boolean;
    settings?: {
        showTextarea?: boolean;
        noBorder?: boolean;
        useTranslation?: boolean;
    };
    disabled: boolean;
    setValue: (value: any, index: number) => void;
}

const TextBubble: React.FC<TextBubbleProps> = ({
    index,
    disableAddBubble,
    settings,
    setValue,
    content,
    defaultText,
    disabled,
    langName
}: TextBubbleProps) => {
    const validationService = new ValidationService();
    const { t } = useTranslation();
    const defaultTextTranslation = settings?.useTranslation
        ? getTranslation(t, defaultText, { lng: langName }, '')
        : defaultText;
    React.useEffect(() => {
        if (
            defaultTextTranslation &&
            validationService.isEmpty(content?.text)
        ) {
            setValue(defaultTextTranslation, index);
        }
    }, []);
    return (
        <BubbleDragContainer
            index={index}
            disableAddBubble={disableAddBubble}
            disabled
        >
            {settings?.showTextarea ? (
                <textarea
                    className="form-group__control"
                    style={{
                        resize: 'vertical',
                        height: '200px',
                        minHeight: '100px'
                    }}
                    onChange={(e) => {
                        setValue(e.target.value, index);
                    }}
                    value={content.text}
                    disabled={disabled}
                    rows={5}
                />
            ) : (
                <input
                    className="form-group__control"
                    onChange={(e) => {
                        setValue(e.target.value, index);
                    }}
                    value={content.text}
                    disabled={disabled}
                />
            )}
        </BubbleDragContainer>
    );
};

export default TextBubble;
